import { render } from "./CxPopper.vue?vue&type=template&id=08b07569"
import script from "./CxPopper.vue?vue&type=script&lang=js"
export * from "./CxPopper.vue?vue&type=script&lang=js"

import "./CxPopper.vue?vue&type=style&index=0&id=08b07569&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__